export const environment = {
  production: true,
  fillWithFakeData: false,
  version: require('../../package.json').version
};
